// 'use client';
// import React, { useEffect } from 'react';
// //= Scripts

// import scrollToTop from '../../../common/scrollToTop';
// const ProgressScroll = () => {
//   useEffect(() => {
//     scrollToTop();
//   }, []);

//   return (
//     <div className="progress-wrap cursor-pointer">
//       <svg
//         className="progress-circle svg-content"
//         width="100%"
//         height="100%"
//         viewBox="-1 -1 102 102"
//       >
//         <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
//       </svg>
//     </div>
//   );
// };

// export default ProgressScroll;


'use client';
import React, { useEffect } from 'react';
//= Scripts
import scrollToTop from '../../../common/scrollToTop';
import '@fortawesome/fontawesome-free/css/all.min.css';


const ProgressScroll = () => {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div>
       <a
        href="tel:+917090980320"
        className="call-icon"
      >
        <i className="fas fa-phone"></i>
      </a>

      {/* WhatsApp Icon */}
      <a
        href="https://wa.me/917090980320?text=Hi!%20I%27d%20like%20to%20know%20more%20about%20your%20services"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-icon"
      >
        <i className="fab fa-whatsapp"></i>
      </a>

  
      {/* Progress Bar */}
      <div
        className="progress-wrap cursor-pointer"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 999,
        }}
      >
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
    </div>
  );
};

export default ProgressScroll;

